"use client";

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import {
    BsGrid1X2Fill,
    BsBuilding,
    BsPeople,
    BsBoxArrowLeft,
    BsGear,
    BsBriefcase,
    BsBank,
    BsCartCheck
} from 'react-icons/bs';

import { useAuth } from '../../context/AuthContext';

export default function Sidebar() {
    const pathname = usePathname();
    const { logout } = useAuth();

    const linkClasses = "flex items-center p-3 my-1 rounded-lg text-gray-300 transition-colors duration-200";
    const activeLinkClasses = "bg-indigo-600 text-white shadow-lg";
    const inactiveLinkClasses = "hover:bg-gray-700 hover:text-white";

    const menuItems = [
        { href: '/dashboard', icon: <BsGrid1X2Fill className="mr-3" />, label: '儀表板' },
        { href: '/companies', icon: <BsBriefcase className="mr-3" />, label: '公司管理' },
        { href: '/school', icon: <BsBuilding className="mr-3" />, label: '學院管理' },
        { href: '/orders', icon: <BsCartCheck className="mr-3" />, label: '訂單管理' },
        { href: '/payouts', icon: <BsBank className="mr-3" />, label: '提款管理' }, // Add new menu item
        { href: '/users', icon: <BsPeople className="mr-3" />, label: '帳號管理' },
    ];

    return (
        <aside className="w-64 bg-gray-800 text-white flex flex-col min-h-screen shadow-2xl">
            <div className="p-6 border-b border-gray-700">
                <h1 className="text-2xl font-bold text-white tracking-wider">系統管理</h1>
            </div>
            <nav className="flex-grow p-4">
                <ul className="space-y-1">
                    {menuItems.map((item) => (
                        <li key={item.href}>
                            <Link
                                href={item.href}
                                className={`${linkClasses} ${pathname === item.href || (item.href !== '/dashboard' && pathname.startsWith(item.href)) ? activeLinkClasses : inactiveLinkClasses}`}
                            >
                                {item.icon}
                                <span>{item.label}</span>
                            </Link>
                        </li>
                    ))}
                </ul>
            </nav>
            <div className="p-4 border-t border-gray-700">
                <button
                    onClick={logout}
                    className="w-full flex items-center p-3 rounded-lg text-gray-300 hover:bg-red-600 hover:text-white transition-colors duration-200"
                >
                    <BsBoxArrowLeft className="mr-3" />
                    <span>登出</span>
                </button>
            </div>
        </aside>
    );
}